import { ChevronLeft, ChevronRight } from "lucide-react";
import React from "react";

const Paginate = ({
  currentPage,
  setCurrentPage,
  totalPages,
}: {
  currentPage: number;
  setCurrentPage: (page: number) => void;
  totalPages: number;
}) => {
  const pages = Array.from({ length: totalPages }, (_, i) => i + 1);

  const getDisplayedPages = () => {
    if (totalPages <= 7) return pages;

    if (currentPage <= 4) return [...pages.slice(0, 5), "...", totalPages];
    if (currentPage >= totalPages - 3)
      return [1, "...", ...pages.slice(totalPages - 5)];

    return [
      1,
      "...",
      ...pages.slice(currentPage - 2, currentPage + 1),
      "...",
      totalPages,
    ];
  };

  return (
    <div className="flex justify-center items-center gap-3 my-12 select-none mt-20">
      {/* Next Button */}
      <button
        onClick={() => setCurrentPage(currentPage + 1)}
        disabled={currentPage === totalPages}
        className={`px-4 py-2 rounded-xl text-sm md:text-base cursor-pointer disabled:cursor-not-allowed transition-all duration-300 shadow-sm
        ${
          currentPage === totalPages
            ? "bg-gray-200 text-gray-400 cursor-not-allowed"
            : "bg-main text-white"
        }`}
      >
        <ChevronRight />
      </button>

      {/* Page Numbers */}
      <div className="flex flex-row-reverse items-center gap-2">
        {getDisplayedPages().map((page, idx) =>
          page === "..." ? (
            <span
              key={idx}
              className="px-3 text-gray-400 font-semibold text-lg"
            >
              ...
            </span>
          ) : (
            <button
              key={idx}
              onClick={() => setCurrentPage(page as number)}
              className={`w-10 h-10 rounded-xl flex items-center cursor-pointer justify-center text-sm md:text-base transition-all duration-300
              ${
                currentPage === page
                  ? "bg-main text-white shadow-md scale-105"
                  : "bg-gray-100 text-gray-700"
              }`}
            >
              {page}
            </button>
          )
        )}
      </div>

      {/* Previous Button */}
      <button
        onClick={() => setCurrentPage(currentPage - 1)}
        disabled={currentPage === 1}
        className={`px-4 py-2 rounded-xl text-sm md:text-base transition-all cursor-pointer disabled:cursor-not-allowed duration-300 shadow-sm 
        ${
          currentPage === 1
            ? "bg-gray-200 text-gray-400 cursor-not-allowed"
            : "bg-main text-white"
        }`}
      >
        <ChevronLeft />
      </button>
    </div>
  );
};

export default React.memo(Paginate);
